@if (page$ | async; as page) {
  @let advertisementEnabled = page.advertisement?.enabled;
  @let advertisementLabel = page.advertisement?.label;

  @if (advertisementEnabled && advertisementLabel) {
    <ui-text-label [text]="advertisementLabel"></ui-text-label>
  }

  <div class="cms-page-layout" [class]="page.layout">
    @switch (page.layout) {
      @case ('blocks-8-4-12') {
        <div class="block1">
          <ng-container #pageBlock></ng-container>
        </div>
        <div class="block2">
          <ng-container #pageBlock></ng-container>
        </div>
        <div class="block3">
          <ng-container #pageBlock></ng-container>
        </div>
      }
      @default {
        <ng-container #pageBlock></ng-container>
      }
    }
  </div>
} @else if (showErrorFallback()) {
  <ui-maintenance variant="cms"></ui-maintenance>
}
